<template>
<div :class="isIos?'has_nav':''">
  <div class="pdf_nav" v-if="isIos">
    <span class="back" @click="goPage"></span>
    充值协议
  </div>
   <div id="pdf" style="display:none">

  </div>
  <div id="pdf2" >

  </div>
</div>
 
</template>

<script>
import Pdfh5 from 'pdfh5'
import "pdfh5/css/pdfh5.css";
import { getAgreement } from "../../api/usAgreement";
export default {
  data() {
    return {
      isIos:this.$route.query.type=='ios',
      code: this.$route.query.code,
      pdfh5: null,
      pdfH5Url: '',
      pdfh52:null
    }
  },
  created(){

  },
  mounted(){
    this.getUsAgreement()

  },
  methods: {
    goPage(){
      this.handlerWebkitFunction('over')
    },
    async getUsAgreement() {
      let data = {
        info: this.code
      }
      const res = await getAgreement(data)
        if(res.data.code == 200) {
          this.pdfH5Url = res.data.data.content
          // pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以用来操作pdf，监听相关事件
          // pdfh5 = new Pdfh5(selector, options) goto初始到第几页，logo设置每一页pdf上的水印
          this.pdfh5 = new Pdfh5('#pdf', { pdfurl: res.data.data.content})
          // 监听pdf准备开始渲染，此时可以拿到pdf总页数
          this.pdfh5.on('ready', function () {
            console.log('总页数:' + this.totalNum)
             
          })
          // 监听pdf加载完成事件，加载失败、渲染成功都会触发
          this.pdfh5.on('complete', (status, msg, time) => {
         //   alert(1)
            console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒')
             this.pdfh52 = new Pdfh5('#pdf2', { pdfurl: res.data.data.content})
          })

        }
        // pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以用来操作pdf，监听相关事件
    // pdfh5 = new Pdfh5(selector, options) goto初始到第几页，logo设置每一页pdf上的水印
 
    },
    handlerWebkitFunction(name, params, callback) {
      let that = this
      var callbackName = name + 'Callback'
      window.webkit.messageHandlers[name].postMessage(
        JSON.stringify({
          ...params,
          callbackName,
        })
      )
      window[callbackName] = function(res) {
        callback && callback(JSON.parse(that.$Base64.decode(res)))
      }
    },
  }
}
</script>

<style >

.back {
width: 10px;
height: 10px;
border: solid black;
border-width: 0 1px 1px 0;
transform: rotate(135deg);
-webkit-transform: rotate(135deg);
display: block;
position: absolute;
left:15px;
top:14.8px;

}
.has_nav{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top:40px ;
}

  .pdf_nav{
    width: 100%;
    height: 40px;
    position: fixed;
    top: 0;
    left: 0;
   z-index: 111;
    line-height: 40px;
    font-size: 18px;
    text-align: center;
    background: #fff;
    box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.06);
  }
 /* @import "pdfh5/css/pdfh5.css"; */
    *{
    padding: 0;
    margin: 0;
    }
    html,body,#pdf {
    width: 100%;
    height: 100%;
    }
    .pinch-zoom-container {
      height: auto !important; 
    }
</style>